export class ContainerItemTreeGridDTO {
  id: string;
  parentContainerId: string;
  name: string;
  objectType: string;
  isContainer: boolean;
  unitOfMeasureCode: string;
  quantity: number | null;
  isActive: boolean;
  modifiedBy: string | null;
  modifiedDate: string | null;
  qtyToMove: number | null;
  collapsed: boolean | null;
  childContainerItemTreeGridDtos: ContainerItemTreeGridDTO[];
}
